<div class="truck-details-dialog">
  <div class="dialog-layout">
    <h2 class="dialog-h2" *ngIf="truck.id != null">
      {{ 'edit truck' | translate: ['tmc.truck-details-dialog.edit.title', translationService.language]}}
    </h2>
    <h2 class="dialog-h2" *ngIf="truck.id == null">
      {{ 'register truck' | translate: ['tmc.truck-details-dialog.register.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>
    <div class="dialog-content truck-details-dialog-content">

      <form #truckForm="ngForm">
        <div class="header-area">
          <div class="row">
            <h5>{{'master data' | translate: ['tmc.truck-details-dialog.masterdata.title',
              translationService.language]}}</h5>
          </div>
          <div class="row">

            <mat-form-field class="col first">
              <input [formControl]="numberPlateControl" type="text" name="numberPlate"
                [required]="cps.isRequired('ui-component.truck-details-dialog.number-plate.min-length', true)"
                [minlength]="cps.getClientParamValue('ui-component.truck-details-dialog.number-plate.min-length', 0)"
                [maxlength]="100" matInput [matAutocomplete]="autocomplateNumberplate"
                placeholder="{{'numberPlate' | translate: ['tmc.truck-details-dialog.masterdata.numberPlate', translationService.language]}}"
                [readonly]="readonly">
              <mat-autocomplete autoActiveFirstOption #autocomplateNumberplate="matAutocomplete"
                [displayWith]="getDisplayFn()" (optionSelected)="numberplateAutocompleteSelection($event)">
                <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let truckDetails of autocomplateTrucks" [value]="truckDetails">
                    <span>{{truckDetails.numberPlate}}</span>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="col">
              <input matInput name="driver" #name="ngModel" [(ngModel)]="truck.driver"
                [required]="cps.isRequired('ui-component.truck-details-dialog.driver.min-length', true)"
                [maxlength]="255" [readonly]="readonly"
                [minlength]="cps.getClientParamValue('ui-component.truck-details-dialog.driver.min-length', 0)"
                [maxlength]="255"
                placeholder="{{'driver' | translate: ['tmc.truck-details-dialog.masterdata.driver', translationService.language]}}">
            </mat-form-field>

            <mat-form-field class="col last">
              <input matInput name="coDriver" #firstName="ngModel" [(ngModel)]="truck.coDriver"
                [minlength]="cps.getClientParamValue('ui-component.truck-details-dialog.co-driver.min-length', 0)"
                [required]="cps.isRequired('ui-component.truck-details-dialog.co-driver.min-length', true)"
                [maxlength]="255"
                placeholder="{{'coDriver' | translate: ['tmc.truck-details-dialog.masterdata.coDriver', translationService.language]}}"
                [readonly]="readonly">
            </mat-form-field>

          </div>
          <div class="row">
            <mat-form-field class="col first">
              <input matInput name="carrier" #firstName="ngModel" [(ngModel)]="truck.carrier"
                [minlength]="cps.getClientParamValue('ui-component.truck-details-dialog.carrier.min-length', 0)"
                [required]="cps.isRequired('ui-component.truck-details-dialog.carrier.min-length', true)"
                [maxlength]="255"
                placeholder="{{'carrier' | translate: ['tmc.truck-details-dialog.masterdata.carrier', translationService.language]}}"
                [readonly]="readonly">
            </mat-form-field>
            <mat-form-field class="col ">
              <input matInput name="supplier" #firstName="ngModel" [(ngModel)]="truck.supplier"
                [minlength]="cps.getClientParamValue('ui-component.truck-details-dialog.supplier.min-length', 0)"
                [required]="cps.isRequired('ui-component.truck-details-dialog.supplier.min-length', true)"
                [maxlength]="255"
                placeholder="{{'supplier' | translate: ['tmc.truck-details-dialog.masterdata.supplier', translationService.language]}}"
                [readonly]="readonly">
            </mat-form-field>
            <div class="col first">
              <mat-checkbox name="useGlobalConnect" [(ngModel)]="truck.useGlobalConnect"
                [disabled]="!useGlobalConnectEditable">
                {{'useGlobalConnect' | translate: ['tmc-yard.entity.truck.useGlobalConnect',
                translationService.language]}}
              </mat-checkbox>
            </div>
          </div>
          <div class="row" *ngIf="serviceVehiclesEnabled">
            <mat-checkbox class="col first" name="serviceTruck" [(ngModel)]="truck.serviceTruck">
              {{'serviceTruck' | translate: ['tmc-yard.entity.truck.service-truck', translationService.language]}}
            </mat-checkbox>
          </div>

        </div>
        <div class="row">
          <h5>{{'Supplementary equipment' | translate:
            ['tmc.truck-details-dialog.supplementaryequipment.title',
            translationService.language]}}</h5>
        </div>
        <app-truck-supplementary-equipment [truck]="truck" #truckSupplementaryEquipmentComponent>
        </app-truck-supplementary-equipment>
      </form>
    </div>
    <app-service-response [responseMessages]="responseMessages"></app-service-response>
    <i class="horizontal-divider"></i>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" [mat-dialog-close]="true">{{'close' | translate:
        ['tmc.truck-details-dialog.action.close', translationService.language]}}</button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="save()" class="confirm-button" [disabled]="isSaveDisabled() || isLoading"
        *ngIf="!readonly">{{'save' | translate: ['tmc.truck-details-dialog.action.save',
        translationService.language]}}</button>
    </sc-actionbar>

  </div>
</div>